var _path, _ellipse, _mask, _path2, _path3, _rect, _path4, _ellipse2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9672 30.5414C29.0955 32.3412 27.2353 33.51 24.8418 33.8883C22.4505 34.2662 19.5756 33.8415 16.798 32.4961C14.0204 31.1507 11.9049 29.1581 10.719 27.0475C9.53195 24.935 9.29588 22.7508 10.1676 20.951C11.0394 19.1512 12.8996 17.9824 15.2931 17.6042C17.6844 17.2263 20.5593 17.651 23.3369 18.9964C26.1145 20.3418 28.23 22.3343 29.4159 24.4449C30.6029 26.5575 30.839 28.7417 29.9672 30.5414Z",
    fill: "#282828",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9167,
    cy: 24.2209,
    rx: 7,
    ry: 6,
    transform: "rotate(25.8444 16.9167 24.2209)",
    fill: "#B7B7B7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_224_70023",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3764 19.2728L19.4766 14.4775L15.2263 23.2524L15.0239 23.6702L15.074 23.6945C14.7305 25.2781 16.2657 27.367 18.7594 28.5749C21.2531 29.7828 23.8438 29.6924 24.8735 28.4411L24.9237 28.4654L25.1261 28.0476L29.3764 19.2728Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3764 19.2728L19.4766 14.4775L15.2263 23.2524L15.0239 23.6702L15.074 23.6945C14.7305 25.2781 16.2657 27.367 18.7594 28.5749C21.2531 29.7828 23.8438 29.6924 24.8735 28.4411L24.9237 28.4654L25.1261 28.0476L29.3764 19.2728Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4766 14.4775L19.9125 13.5776L19.0125 13.1416L18.5766 14.0416L19.4766 14.4775ZM29.3764 19.2728L30.2763 19.7087L30.7123 18.8087L29.8123 18.3728L29.3764 19.2728ZM15.0239 23.6702L14.1239 23.2343L13.688 24.1343L14.5879 24.5702L15.0239 23.6702ZM15.074 23.6945L16.0513 23.9064L16.218 23.1375L15.5099 22.7945L15.074 23.6945ZM24.8735 28.4411L25.3095 27.5412L24.6013 27.1982L24.1014 27.8057L24.8735 28.4411ZM24.9237 28.4654L24.4877 29.3654L25.3877 29.8013L25.8236 28.9013L24.9237 28.4654ZM19.0406 15.3775L28.9404 20.1727L29.8123 18.3728L19.9125 13.5776L19.0406 15.3775ZM16.1262 23.6883L20.3765 14.9135L18.5766 14.0416L14.3263 22.8164L16.1262 23.6883ZM15.9238 24.1061L16.1262 23.6883L14.3263 22.8164L14.1239 23.2343L15.9238 24.1061ZM15.5099 22.7945L15.4598 22.7702L14.5879 24.5702L14.6381 24.5945L15.5099 22.7945ZM19.1953 27.6749C18.0719 27.1308 17.1973 26.4025 16.6531 25.6761C16.094 24.9297 15.9646 24.306 16.0513 23.9064L14.0967 23.4825C13.8399 24.6666 14.3063 25.8792 15.0524 26.8751C15.8134 27.891 16.9532 28.8112 18.3235 29.4749L19.1953 27.6749ZM24.1014 27.8057C23.8416 28.1214 23.2719 28.4065 22.3397 28.4305C21.4324 28.4539 20.3187 28.2191 19.1953 27.6749L18.3235 29.4749C19.6937 30.1386 21.1223 30.4625 22.3912 30.4299C23.6352 30.3978 24.8758 30.0121 25.6457 29.0766L24.1014 27.8057ZM25.3596 27.5654L25.3095 27.5412L24.4376 29.3411L24.4877 29.3654L25.3596 27.5654ZM24.2261 27.6116L24.0237 28.0295L25.8236 28.9013L26.026 28.4835L24.2261 27.6116ZM28.4764 18.8368L24.2261 27.6116L26.026 28.4835L30.2763 19.7087L28.4764 18.8368Z",
    fill: "black",
    mask: "url(#path-3-inside-1_224_70023)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.9414,
    y: 15.6855,
    width: 2,
    height: 7,
    transform: "rotate(25.8444 19.9414 15.6855)",
    fill: "#B7B7B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9232 15.8487C33.2831 19.2347 28.3502 20.4429 23.7718 18.2252C19.1935 16.0076 17.0834 11.388 18.7235 8.002C20.3636 4.61601 25.2965 3.40784 29.8748 5.62549C34.4532 7.84314 36.5632 12.4627 34.9232 15.8487Z",
    fill: "#282828",
    stroke: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.1093,
    cy: 9.37119,
    rx: 4,
    ry: 3.5,
    transform: "rotate(25.8444 24.1093 9.37119)",
    fill: "#B7B7B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2305,
    y: 32.293,
    width: 2,
    height: 13,
    transform: "rotate(25.8444 15.2305 32.293)",
    fill: "#DDDADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPhoto);
export default __webpack_public_path__ + "static/media/pin-photo.3df25edf76be4474ad4336683d272b4e.svg";
export { ForwardRef as ReactComponent };